module.exports = __webpack_public_path__ + "img/islington_house_b2.a57897c5.jpg";